import {BaseWrapper} from '../../../allkey/framework/parameters/BaseWrapper';
import {BasicCriteria} from '../../../allkey/framework/parameters/BasicCriteria';
import {BasicScenario} from '../../../allkey/framework/parameters/BasicScenario';
import {TimeGap} from '../message/TimeGap';

export class TimeGapWrapper extends BaseWrapper<TimeGap, BasicCriteria, BasicScenario>  {}

